import React, { Component } from 'react';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { StyleSheet, css } from 'aphrodite';

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';

import { DynamicForm } from './DynamicForm';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { CustomDynamicFormDialogStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { AppHelper } from '../../helpers/AppHelper';
import { Tooltip } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
export class DynamicFormDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onCloseModal() {
    this.setState({
      screenMessage: ''
    });
    this.props.onClosed();
  }

  fullWidthCondition(fullWidthDialog) {
    if (fullWidthDialog) {
      return true
    }
    // if (window.innerWidth && window.innerWidth < 480) {
    //   return true
    // }
    return false
  }

  renderFormHeaderTags() {
    const tags = this.props.formDefinition.steps[0].formHeaderTags || []
    return tags.map((tag, index) => {
      return (
        <Tooltip
          title={tag.toolTip}
          placement='bottom-end'
          classes={{ popper: css(Styles.tooltip) }}
          key={index}>
          <div className={css(Styles.formHeaderTags)}>{tag.title}</div>
        </Tooltip>
      )
    })
  }

  render() {
    let dialogHeading = this.props.formDefinition.title
    const title = this.props.formDefinition.steps[0].fields.find(x => x.key === 'title')
    let deleteTitle = 'Delete'
    if (title && title.value) {
      deleteTitle = title.value
    }
    if (!dialogHeading) {
      if (this.props.formDefinition.formType === 'add') {
        dialogHeading = 'Add'
      } else if (this.props.formDefinition.formType === 'edit') {
        dialogHeading = 'Edit'
      } else if (this.props.formDefinition.formType === 'del' || this.props.formDefinition.formType === 'delete') {
        dialogHeading = deleteTitle
      } else {
        dialogHeading = 'Add/Edit/Delete'
      }
    }

    const descriptionCondition = this.props.formDefinition.descriptionCondition
    const dialogDescription = (!descriptionCondition || this.state.descriptionConditionMatch) && this.props.formDefinition.description
    const customStyles = this.props.formDefinition.customStyles
    const hasPreview = !!this.props.formDefinition.preview
    const alwaysShowModalScrollbar = !!this.props.formDefinition.alwaysShowModalScrollbar || hasPreview

    const fullWidthDialog = (this.props.fullWidthDialog && window.innerWidth > 480)
    const maxWidth = this.props.maxWidth || this.props.formDefinition.maxWidth || (hasPreview ? 'lg' : 'md')
    const fullWidth = this.props.fullWidth !== undefined ? this.props.fullWidth : true
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.formDefinition.steps[0].title}
        fullWidth={fullWidth}
        TransitionComponent={window.innerWidth < 768 ? Transition : Fade}
        fullScreen={this.fullWidthCondition(fullWidthDialog)}
        classes={{
          root: css(Styles.customRoot, this.props.nestedDialog && Styles.nestedDialogRoot),
          paper: css(
            Styles.customPaper,
            alwaysShowModalScrollbar && Styles.customPaperWithScrollableBody,
            AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar
          ),
        }}
        BackdropProps={fullWidthDialog && { style: { backgroundColor: 'unset' } }}

        maxWidth={maxWidth}
      >
        <div className={css(
          Styles.modalHeader,
          AppStyles.modalHeader,
          alwaysShowModalScrollbar && Styles.modalHeaderNoShrink
        )}>
          {/* <div className={css(Styles.modalTitle)}>{this.props.formDefinition.steps[0].title}</div> */}
          <div className={css(Styles.modalTitleContainer)}>
            <div className={css(Styles.modalTitle)}>{dialogHeading}</div>
            { dialogDescription &&
            <div className={css(Styles.modalDescription, customStyles && customStyles.modalDescriptionStyles)}>{dialogDescription}</div>}
          </div>
          {this.renderFormHeaderTags()}
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal} disabled={this.state.inProcess}>
            <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
              <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
            </svg>
          </button>
        </div>
        {this.props.formDefinition && this.props.formDefinition.infoLabel &&
          <div className={css(Styles.infoContainer, alwaysShowModalScrollbar && Styles.modalHeaderNoShrink)}>
            <span className={css(Styles.infoLabelText)}>{this.props.formDefinition.infoLabel}</span>
          </div>
        }
        <div className={css(
          Styles.modalContent,
          alwaysShowModalScrollbar && Styles.modalContentAlwaysScroll
        )}>
          {(this.props.formDefinition.formType === 'del' || this.props.formDefinition.formType === 'delete') &&
            <p className={css(Styles.deleteMsg)}>{Helper.getString('deleteConfirmMsg')}</p>
          }
          {this.props.formDefinition.confirmMessage &&
            <p className={css(Styles.confirmMessage, customStyles && customStyles.confirmMessageStyles)}>{this.props.formDefinition.confirmMessage}</p>
          }
          {this.props.isOpen ? <DynamicForm {...this.props} onDescriptionConditionChange={descriptionConditionMatch => this.setState({ descriptionConditionMatch })} /> : ''}
        </div>
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomDynamicFormDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 25,
    paddingBottom: 10
  },
  modalTitle: {
    color: 'black',
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginRight: 28,
    '@media (max-width: 767px)': {
      marginRight: 43,
    }
  },
  modalContent: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  customPaperWithScrollableBody: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
    overflow: 'hidden',
    minHeight: 0,
    '@media (max-width: 767px)': {
      maxHeight: 'calc(100% - 140px)',
    },
  },
  modalHeaderNoShrink: {
    flexShrink: 0,
  },
  modalContentAlwaysScroll: {
    flex: 1,
    minHeight: 0,
    overflowY: 'scroll',
    scrollbarGutter: 'stable',
    WebkitOverflowScrolling: 'touch',
    '::-webkit-scrollbar': {
      width: 10,
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.28)',
      borderRadius: 5,
    },
    '::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
    },
  },
  modalCloseButton: {
    // position: 'absolute',
    // top: 33,
    // right: 30,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer'
  },
  modalCloseIcon: {
    width: 18,
    height: 18
  },

  customRoot: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(10px)',
    zIndex: 13000
  },
  nestedDialogRoot: {
    zIndex: 13001,
  },
  customPaper: {
    borderRadius: 40,
    // minWidth: 600,
    backgroundColor: AppTheme.secondaryBg,
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 767px)': {
      borderRadius: 0,
    },
  },
  formHeaderTags: {
    fontSize: 14,
    padding: '2px 8px',
    border: '1.5px solid #ff0c0d',
    color: '#ff0c0d',
    borderRadius: 16,
    fontWeight: 500
  },
  tooltip: {
    zIndex: 9999999999,
    maxWidth: 250
  },
})
